import React, { useState } from "react";
import { Badge, Collapse, ListGroup } from "react-bootstrap";
import dayjs from "dayjs";

const SUGGESTION_META = {
  NEW: { label: "NEW", bg: "success", text: "Material nuevo para todos" },
  REVIEW: { label: "REVIEW", bg: "primary", text: "Repaso — todos ya lo vieron" },
  MIXED: { label: "MIXED", bg: "warning", text: "Grupo mixto — considera segmentar" },
};

function TopicContinuityRow({ item }) {
  const [expanded, setExpanded] = useState(false);
  const meta = SUGGESTION_META[item.suggestion] ?? SUGGESTION_META.NEW;
  const id = `continuity-${item.topic?.id ?? Math.random()}`;

  return (
    <div className="mb-3">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <strong>{item.topic?.name ?? "Tema"}</strong>
          <span className="ms-2 text-muted small">
            {item.already_taken} de {item.enrolled} ya lo cursaron
          </span>
        </div>
        <div className="d-flex align-items-center gap-2">
          <Badge bg={meta.bg}>{meta.label}</Badge>
          {item.taken_by?.length > 0 && (
            <button
              className="btn btn-sm btn-link p-0 text-muted"
              style={{ minHeight: 44, minWidth: 44 }}
              onClick={() => setExpanded((v) => !v)}
              aria-expanded={expanded}
              aria-controls={id}
            >
              {expanded ? "Ocultar" : "Quienes ya lo vieron"}
            </button>
          )}
        </div>
      </div>
      <small className="text-muted d-block">{meta.text}</small>
      <Collapse in={expanded}>
        <div id={id}>
          <ListGroup variant="flush" className="mt-2">
            {item.taken_by?.map((entry) => (
              <ListGroup.Item
                key={entry.student}
                className="py-1 px-0 d-flex justify-content-between"
              >
                <span>{entry.name}</span>
                <span className="text-muted small">
                  {dayjs(entry.last_seen_date).format("D MMM YYYY")} · score {entry.last_score}
                </span>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
      </Collapse>
    </div>
  );
}

function ContinuityPanel({ data, isLoading, error }) {
  if (isLoading) {
    return <p className="text-muted small">Cargando continuidad…</p>;
  }
  if (error) {
    return (
      <p className="text-muted small">
        No se pudo cargar la continuidad de temas.
      </p>
    );
  }
  if (!data || data.length === 0) {
    return <p className="text-muted small">Sin temas asignados a esta clase.</p>;
  }

  return (
    <div>
      {data.map((item, i) => (
        <TopicContinuityRow key={item.topic?.id ?? i} item={item} />
      ))}
    </div>
  );
}

export { ContinuityPanel };
